import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex min-h-screen flex-col font-sans text-slate-900 antialiased selection:bg-slate-900 selection:text-white" data-id="element-392">
      <Header data-id="element-393" />
      <main className="flex-1 pt-16" data-id="element-394">{children}</main>
      <Footer data-id="element-395" />
    </div>;
}